import styled from "styled-components";

export const StyledOverlay = styled.div`
  background-color: transparent;
  position: absolute;
  width: 100%;
  z-index: 3;
  height: ${(props) => (props.active ? "200%" : "20px")};
  top: ${(props) => (props.active ? "-50%" : "0")};
`;
export const StyledToolbar = styled.div`
  background-color: rgb(206, 205, 205);
  border: 1px solid rgb(59, 59, 59);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  flex-direction: row;
  height: 20px;
`;

export const TileToolbarTitle = styled.div`
  box-sizing: border-box;
  padding: 0 5px;
  text-align: center;
  color: rgb(58, 58, 58);
  flex: 1;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Spacer = styled.div`
  height: 24px;
  width: 24px;
`;
